import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom'

import { Fire, Tools, Time } from '../../../services'

import { Headerbar, FormInput, HTMLEditor, OnOff, MyDateTimePicker, ConfirmLink, ClickToCopy, YesNo, Loader, EditContainer, ImagesPicker, Select } from '../../Reusable'

import FadeIn from 'react-fade-in';

import TicketingTickets from '../../Ticketing/TicketingTickets'
import TicketingPromos from '../../Ticketing/TicketingPromos'
import TicketingOrders from '../../Ticketing/TicketingOrders'

import SelectAdCategory from './SelectAdCategory'
import SelectAdPro from './SelectAdPro'

import AdValidator from './AdValidator'

const { useHistory } = require('react-router-dom')

interface Props {
  tools: any;
}
const EventForm: React.FC<Props> = (props) => {
  const { item, saving, save, changed, onChange } = props.tools
  const [errors, setErrors] = React.useState<any>({})
  const user = useSelector(state => state.authReducer.user)
  
  React.useEffect(() => {
    updateErrors(item)
  }, [item])
 
  const updateErrors = (item: any) => {
    const errors: any = AdValidator.getInfoErrors(item)
    setErrors(errors)
  }

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Informations</h3>
      </div>
      <div className="card-body">
        <div className="item-add-form">

          { item.id &&
            <div style={{marginBottom: 20}}>
              Lien de l'évènement: <ClickToCopy title={item.share_link} toCopy={item.share_link} />
            </div>
          }

          <SelectAdCategory item={item} onChange={(cats) => onChange('categories', cats)} />

          { user.admin &&
            <SelectAdPro item={item} onChange={(proId) => onChange('proId', proId)} />
          }

          { user.admin &&
            <OnOff
              label="Edition limité"
              checked={item.isLimited || false}
              onChange={(checked: boolean) => onChange('isLimited', checked)}
              />
          }

          <FormInput
            disabled={saving}
            type="text"
            error={errors.name}
            placeholder="Nom de l'évènement"
            value={item.name}
            onChange={(evt: any) => onChange('name', evt.target.value)}
          />

          <FormInput
            disabled={saving}
            type="text"
            placeholder="Présentation de l'offre"
            value={item.offer}
            error={errors.offer}
            onChange={(evt: any) => onChange('offer', evt.target.value)}
            />

          <MyDateTimePicker
            dateTitle='Date de début'
            timeTitle='Heure de début'
            spaceBetween
            error={errors.dateStart}
            date={item.dateStart}
            onChange={(date) => onChange('dateStart', date)}
            />

          <MyDateTimePicker
            dateTitle='Date de fin'
            timeTitle='Heure de fin'
            spaceBetween
            error={errors.dateEnd}
            date={item.dateEnd}
            onChange={(date) => onChange('dateEnd', date)}
            />

          <div className="lined-inputs">
            <FormInput
              disabled={saving}
              error={errors.address}
              type="text"
              placeholder="Adresse"
              value={item.address}
              onChange={(evt: any) => onChange('address', evt.target.value)}
            />

            <div style={{display: 'flex', flexDirection: 'row'}}>
              <FormInput
                disabled={saving}
                error={errors.city}
                placeholder="Ville"
                type="text"
                value={item.city}
                onChange={(evt: any) => onChange('city', evt.target.value)}
              />
              <FormInput
                disabled={saving}
                error={errors.postal_code}
                placeholder="Code Postal"
                type="number"
                value={item.postal_code}
                onChange={(evt: any) => onChange('postal_code', evt.target.value)}
              />
            </div>
          </div>

          <HTMLEditor
            disabled={saving}
            error={errors.description}
            value={item.description}
            placeholder="Décrivez votre évènement..."
            onChange={(val: string) => onChange('description', val)}
            />

          { (user.canDisableTicketing || user.admin) &&
            <React.Fragment>
              <YesNo
                label="Utiliser la billeterie Pop Out"
                value={item.hasTicketing || false}
                onChange={(ticketing) => onChange('hasTicketing', ticketing)}
                />

              <FormInput
                disabled={saving || item.hasTicketing}
                error={errors.link}
                type="text"
                placeholder="Lien du site web"
                value={item.hasTicketing ? '' : item.link}
                onChange={(evt: any) => onChange('link', evt.target.value)}
                />
            </React.Fragment>
          }

        </div>

        <div className="centered">
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={save}
            disabled={saving || !changed || errors.name !== undefined}
            >
            { saving ? 'Chargement...' : 'Enregistrer' }
          </button>
        </div>
      </div>
    </div>
  )
}

export default EventForm
